"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStore = exports.Store = void 0;
var pub_sub_1 = require("./pub-sub");
var Store = /** @class */ (function () {
    function Store(eventDescriptor) {
        this.publisher = new pub_sub_1.ConcretePublisher();
        this.errorPublisher = new pub_sub_1.ConcretePublisher();
        this.value = eventDescriptor.initialValue;
        this.initialValue = eventDescriptor.initialValue;
        this.reducer = eventDescriptor.reducer;
    }
    Store.prototype.subscribe = function (subscriber, receiveLastValue) {
        if (receiveLastValue === void 0) { receiveLastValue = false; }
        var _subscriber = {
            update: subscriber,
        };
        if (receiveLastValue)
            subscriber(this.get());
        return this.publisher.subscribe(_subscriber);
    };
    Store.prototype.subscribeError = function (subscriber) {
        var _subscriber = {
            update: subscriber,
        };
        return this.errorPublisher.subscribe(_subscriber);
    };
    Store.prototype.dispatch = function (eventValue) {
        var value = this.reducer
            ? this.reducer(this.value, eventValue)
            : eventValue;
        this.value = value;
        this.publisher.notify(Object.freeze(value));
    };
    Store.prototype.dispatchError = function (value) {
        this.errorPublisher.notify(value);
    };
    Store.prototype.get = function () {
        return Object.freeze(this.value);
    };
    /**
     * Removes all data from the Event store.
     *
     * @param {boolean} dispatch -
     */
    Store.prototype.clear = function (dispatch) {
        if (dispatch === void 0) { dispatch = false; }
        this.value = this.initialValue;
        if (dispatch) {
            this.dispatch(this.value); // Empty dispatch
        }
    };
    return Store;
}());
exports.Store = Store;
/**
 * Creates an event from a descriptor.
 *
 * @param {StoreParams} storeDescriptor - Event options.
 * @returns {Store} - Event object.
 */
function createStore(storeDescriptor) {
    return new Store(storeDescriptor);
}
exports.createStore = createStore;
